module.exports = __webpack_public_path__ + "dd1b4d43fc9ac65fa1c9aac814d2b266.jpg";